// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay with blur effect */
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    backdrop-filter: blur(10px); /* Applies the blur effect */
    z-index: 1000; /* Ensures the overlay stays on top */
}

/* Centering the warning dialog */
.warning-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* Centers the warning */
    background-color: white;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000; /* Ensures the dialog appears above the overlay */
    text-align: center;
    max-width: 400px;
    width: 80%; /* Responsive width */
}

.warning-dialog p {
    margin: 0;
    font-size: 16px;
    color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/components/AutoLogout.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,gCAAgC;IAChE,2BAA2B,EAAE,4BAA4B;IACzD,aAAa,EAAE,qCAAqC;AACxD;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC,EAAE,wBAAwB;IAC1D,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,aAAa,EAAE,iDAAiD;IAChE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU,EAAE,qBAAqB;AACrC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf","sourcesContent":["/* Overlay with blur effect */\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n    backdrop-filter: blur(10px); /* Applies the blur effect */\n    z-index: 1000; /* Ensures the overlay stays on top */\n}\n\n/* Centering the warning dialog */\n.warning-dialog {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); /* Centers the warning */\n    background-color: white;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 1000; /* Ensures the dialog appears above the overlay */\n    text-align: center;\n    max-width: 400px;\n    width: 80%; /* Responsive width */\n}\n\n.warning-dialog p {\n    margin: 0;\n    font-size: 16px;\n    color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
